module.exports = __webpack_public_path__ + "static/media/logo-roue-biodiversite-centre.74b52d75.png";